import React from "react";

const Payment = () => {
  return (
    <div>
      <h3 className="text-3xl m-3">Payment coming soon!</h3>
    </div>
  );
};

export default Payment;
